export interface ProductOption {
  key: string;
  displaySku: string | null;
  displayDescription: string | null;
}

/**
 * The catalog page as options, minus `excludeKey` when given, with the current
 * selection kept at the top: the trigger can only keep naming the picked SKU
 * while that SKU is still in the list, and a later search returns a page it
 * isn't on.
 */
export function buildProductOptions(
  edges: readonly ProductOption[],
  excludeKey: string | undefined,
  selectedKey: string | null,
): ProductOption[] {
  const options: ProductOption[] = [];
  for (const edge of edges) {
    if (edge.key === excludeKey) continue;
    options.push({
      key: edge.key,
      displaySku: edge.displaySku,
      displayDescription: edge.displayDescription,
    });
  }
  if (selectedKey !== null && !options.some((o) => o.key === selectedKey)) {
    options.unshift({
      key: selectedKey,
      displaySku: selectedKey,
      displayDescription: null,
    });
  }
  return options;
}
